module.exports = "<div [ngClass]=\"{expandable: shouldExpand, expanded: expanded}\">\n  <div class=\"content\">\n  \t<ng-content></ng-content>\n  </div>\n  <div *ngIf=\"shouldExpand\" class=\"toggle\" (click)=\"toggle()\" [ngClass]=\"{expand: !expanded}\">{{expanded ? \"...Less\" : \"...More\"}}</div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/components/show-more/show-more.component.html
// module id = ../../../../../src/app/components/show-more/show-more.component.html
// module chunks = main